export default {
    imageDashboardTransaction: {
        action: 'Handling',
        transactionId: 'Transaksjons-ID',
        variationCount: 'Antall Variasjoner',
        date: 'Dato',
        cost: 'Kostnad',
        description: 'Beskrivelse',
        selectedImage: 'Valgt Bilde',
        goTo: 'Gå til',
    },
};
